"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveStateMachine = deriveStateMachine;
exports.generateReactFlowElements = generateReactFlowElements;
function deriveStateMachine(transitionMeta) {
    const edges = [];
    const statesSet = new Set();
    const targetStates = new Set();
    const sourceStates = new Set();
    for (const [transitionName, meta] of Object.entries(transitionMeta)) {
        const { from: fromStates, to: toState } = meta;
        statesSet.add(toState);
        targetStates.add(toState);
        for (const fromState of fromStates) {
            statesSet.add(fromState);
            sourceStates.add(fromState);
            edges.push({
                from: fromState,
                to: toState,
                transitionName,
            });
        }
    }
    const states = Array.from(statesSet);
    const initialStates = states.filter((state) => !targetStates.has(state));
    const terminalStates = states.filter((state) => !sourceStates.has(state));
    return {
        states,
        edges,
        initialStates,
        terminalStates,
    };
}
/**
 * Generates React Flow nodes and edges from a state machine graph.
 * Positions are initialized to (0,0) and should be laid out using ELK or similar.
 */
function generateReactFlowElements(graph, options = {}) {
    const { currentState, visitedStates = [] } = options;
    const visitedSet = new Set(visitedStates);
    const nodes = graph.states.map((state) => ({
        id: state,
        type: "stateNode",
        data: {
            label: state,
            isInitial: graph.initialStates.includes(state),
            isTerminal: graph.terminalStates.includes(state),
            isCurrent: state === currentState,
            isVisited: visitedSet.has(state) && state !== currentState,
        },
        position: { x: 0, y: 0 },
    }));
    const edges = graph.edges.map((edge, index) => ({
        id: `edge-${index}-${edge.from}-${edge.to}`,
        source: edge.from,
        target: edge.to,
        label: edge.transitionName,
        animated: false,
    }));
    return { nodes, edges };
}
//# sourceMappingURL=stateMachine.js.map